(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('SampleSearch', SampleSearch);

    SampleSearch.$inject = ['$resource'];

    function SampleSearch($resource) {
        var resourceUrl =  'api/_search/samples/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
